<template>
    <div>
        <div class="active-polls" v-if="activePolls.length > 0">
            <p class="block-h2">Активные опросы</p>
            <poll-form :key="key" v-for="(poll, key) in activePolls" :type-poll="'active'" :item="poll"></poll-form>
        </div>
        <div class="active-polls" v-if="disActivePolls.length > 0">
            <p class="block-h2">Старые опросы</p>
            <poll-form :key="key" v-for="(poll, key) in disActivePolls" :type-poll="'disactive'" :item="poll"></poll-form>
        </div>

    </div>
</template>


<script>
    import PollForm from "./PollForm";

    export default {
        name: 'poll-list',
        components: { PollForm },
        data() {
            return {
                polls
            }
        },
        computed: {
            activePolls() {
                return polls.filter(poll => poll.published == true);
            },
            disActivePolls() {
                return polls.filter(poll => poll.published == false);
            }
        }
    }
</script>


// WEBPACK FOOTER //
// resources/js/components/poll/PollList.vue